import React from 'react';
import 'flag-icons/css/flag-icons.min.css';

interface FlagIconProps {
  countryCode: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const FlagIcon: React.FC<FlagIconProps> = ({ 
  countryCode, 
  size = 'sm', 
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-3',
    md: 'w-6 h-4',
    lg: 'w-8 h-6'
  };

  return (
    <span 
      className={`fi fi-${countryCode.toLowerCase()} inline-block rounded-sm ${sizeClasses[size]} ${className}`}
      role="img"
      aria-label={`Flag of ${countryCode.toUpperCase()}`}
    />
  );
};

export default FlagIcon;